
function initMCSSlider() {
  const sliderEl = document.querySelector('.M-mcs-Swiper');

  if (!sliderEl) return;

  // Prevent duplicate initialization
  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  sliderEl.classList.remove('preview');

  const swiper = new Swiper('.M-mcs-Swiper', {
    speed: 300,
    loop: true,
    centeredSlides: true,

    navigation: {
      nextEl: '.m-mcs-next',
      prevEl: '.m-mcs-prev',
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },

      750: {
        slidesPerView: 3,
        spaceBetween: 20,
      },

      950: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });

  // Example slide change event
  swiper.on('slideChange', function () {
    console.log('Active slide:', swiper.realIndex);
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', initMCSSlider);

// Shopify Theme Editor support
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initMCSSlider);
  document.addEventListener('shopify:section:unload', function () {
    const sliderEl = document.querySelector('.M-mcs-Swiper');

    if (sliderEl && sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }
  });
}
document.addEventListener('click', function (e) {
  const button = e.target.closest('.u-fgmcollsblk-toggle');
  if (!button) return;
  const item = button.closest('.u-fgmcollsblk-item');
  const content = item.querySelector('.u-fgmcollsblk-content');
  const isAlreadyActive = item.classList.contains('u-fgmcollsblk-active');
  const allActiveItems = document.querySelectorAll('.u-fgmcollsblk-item.u-fgmcollsblk-active');
  allActiveItems.forEach((activeItem) => {
    activeItem.classList.remove('u-fgmcollsblk-active');
    const activeContent = activeItem.querySelector('.u-fgmcollsblk-content');
    if (activeContent) {
      activeContent.style.maxHeight = null;
    }
  });
  if (!isAlreadyActive) {
    item.classList.add('u-fgmcollsblk-active');
    content.style.maxHeight = content.scrollHeight + 'px';
  }
});